import React from "react";
import { Link } from "react-router-dom";
import "./Cards.css";
import { useInView } from "react-intersection-observer";

function Cards() {
    const { ref: cardsRef, inView: cardsVisible } = useInView({
        triggerOnce: true,
        threshold: 0.15,
    });

    return (
        <div
            className={cardsVisible ? "cards-grid cards-grid-visible" : "cards-grid"}
            ref={cardsRef}
        >
            <Link to="/pools" className="cards-link">
                <div className="card card0">
                    <div className="border">
                        <h2 className="card0-h2">Pool</h2>
                    </div>
                </div>
            </Link>
            <Link to="/patio" className="cards-link">
                <div className="card card1">
                    <div className="border">
                        <h2>Patio</h2>
                    </div>
                </div>
            </Link>
            <Link to="/kitchen" className="cards-link">
                <div className="card card2">
                    <div className="border">
                        <h2>Kitchen</h2>
                    </div>
                </div>
            </Link>
            <Link to="/yardscape" className="cards-link">
                <div className="card card3">
                    <div className="border">
                        <h2>Yardscape</h2>
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default Cards;
